<template>
  <li class="flex bg-white dark:bg-gray-900 rounded-2xl">
    <slot></slot>
  </li>
</template>

<script></script>

<style></style>
